import { c as _c } from "react/compiler-runtime";
import { FaroTextButton } from "@components/common/faro-text-button";
import { Alert } from "@flat-ui";
/**
 * Tells that something the add-to-team dialogs depend on could not be loaded. Until it is, no team
 * is known to be safe to pick, so the dialog waits for the user to try again.
 */
export function LoadErrorAlert(t0) {
  const $ = _c(5);
  const {
    title,
    onRetry
  } = t0;
  let t1;
  if ($[0] !== onRetry) {
    t1 = <FaroTextButton onClick={onRetry}>Try again</FaroTextButton>;
    $[0] = onRetry;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1 || $[3] !== title) {
    t2 = <Alert variant="error" title={title} action={t1} />;
    $[2] = t1;
    $[3] = title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}